export const PreviewBanner = () => (
  <div
    data-testid="preview-catalog-banner"
    className="mb-8 flex items-center gap-3 border border-signal/40 bg-signal/5 px-4 py-3"
  >
    <span className="h-1.5 w-1.5 shrink-0 animate-pulse bg-signal" />
    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
      Preview catalog — live pricing, inventory & checkout activate when Shopify connects
    </p>
  </div>
);
